module.exports = __webpack_public_path__ + "img/emergency-icon.8f86be63.svg";